var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":_vm.userRol.base_path}},[_c('feather-icon',{attrs:{"size":"21","icon":"GridIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }